


























import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GTextFormInput',
  props: {
    isLabel: { type: Boolean as PropType<boolean>, default: true },
    valid: { type: Boolean as PropType<boolean>, default: true },
    isTag: { type: Boolean as PropType<boolean>, default: false },
    isPublic: { type: Boolean as PropType<boolean>, default: false },
    exclamation: { type: Array as PropType<string[]>, default: () => [] },
    label: { type: String as PropType<string> },
    value: { type: String as PropType<string>, default: '' },
    name: { type: String as PropType<string>, required: true },
    placeholder: { type: String as PropType<string>, default: '' },
    disabled: { type: Boolean as PropType<boolean>, default: false },
    maxLength: { type: Number as PropType<number>, default: 0 },
    isRequired: { type: Boolean as PropType<boolean>, default: false },
    isPassword: { type: Boolean as PropType<boolean>, default: false },
    underline: { type: Boolean as PropType<boolean>, default: false },
    error: { type: Array as PropType<string[]>, default: () => [] },
  },
  computed: {
    innerValue: {
      get(): string {
        return this.value;
      },
      set(val: string): void {
        this.$emit('input', val);
      },
    },
  },
});
